var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlansIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6646 1.2251V3.4031",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6644 13.3838V15.2054",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6644 10.292V5.95312",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0319 15.4C17.6718 15.4 19 14.0883 19 12.4688V10.1356C17.9149 10.1356 17.041 9.27254 17.041 8.20093C17.041 7.12932 17.9149 6.26535 19 6.26535L18.9991 3.93117C18.9991 2.3117 17.6699 1 16.031 1H3.96902C2.3301 1 1.00094 2.3117 1.00094 3.93117L1 6.34137C2.08511 6.34137 2.95901 7.12932 2.95901 8.20093C2.95901 9.27254 2.08511 10.1356 1 10.1356V12.4688C1 14.0883 2.32822 15.4 3.96808 15.4H16.0319Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon);
export default __webpack_public_path__ + "static/media/plansIcon.59d8469a5e7c1ef5f5274fb6329396c6.svg";
export { ForwardRef as ReactComponent };